import React, { Component } from "react";
import "./skeleton.css";
import "./getgig.css";

const SPOTIFY_QUERY_JOIN =
  "https://accounts.spotify.com/authorize?show_dialog=true&client_id=237066dd57494b8e9842fa6dc07c8cc3&response_type=code&redirect_uri=https%3A%2F%2Fsymphony-v2.firebaseapp.com%2Fcallbackjoin&scope=user-top-read%2Cplaylist-modify-public%2Cplaylist-modify-private%2Cugc-image-upload";


class Getgig extends Component {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    fetch("https://symphony-api.herokuapp.com/api/leave", {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: window.id
      })
    });
    window.location.href = SPOTIFY_QUERY_JOIN
  }
  render() {
    return (
      <div className="container">
        <div className="g-background" />
        <div className="row">
          <div className="twelve columns">
            <div className="g-subtext">You are in the gig:</div>
          </div>
        </div>
        <div className="row">
          <div className="twelve columns">
            <div className="g-gig-name"> {window.gig_name}</div>
          </div>
        </div>
        <div className="row">
          <div className="twelve columns">
            <div className="spotifyplayer">
              <iframe
                src={"https://open.spotify.com/embed?uri=" + window.uri}
                width="100%"
                height="420"
                frameborder="0"
                allowtransparency="true"
                allow="encrypted-media"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="twelve columns">
            <div className="g-button-wrapper">
              <a className="g-leave-link" onClick={this.handleClick}>
              <div className="g-button">leave gig</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Getgig;



// WEBPACK FOOTER //
// ./src/getgig.js